// Stimulus controller to handle errors on the client side when a signature should e available but cannot be retrieved.
// Replaces signature with a notice that it is temporarily unavailable.
import ApplicationController from './application_controller';

export default class extends ApplicationController {
  connect() {
    this.element.onerror = this.error.bind(this);
    // If the image is broken before we had a chance to connect with Stimulus, check to see if the image is broken
    if (this.is_broken) {
      // Handle the broken signature
      this.signature_broken();
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  error(_) {
    this.signature_broken();
  }

  // Swap out the signature with an a notice explaining why it isn't there.
  signature_broken() {
    const notice = document.createElement('p');
    notice.appendChild(
      document.createTextNode(
        'A temporary issue has prevented signature retrieval. We apologize for the inconvenience.'
      )
    );
    notice.className = 'px-2 py-1 mh-50 bg-warning font-weight-bold';
    this.element.replaceWith(notice);
  }

  // Broken signatures will have a 0 natural height and > 0 otherwise
  get is_broken() {
    return this.is_loaded && this.element.naturalHeight === 0;
  }

  get is_loaded() {
    return this.element.complete;
  }
}
